import { createAction } from "@reduxjs/toolkit";
import {
  FETCHING_ASSET_REQUEST,
  FETCHING_ASSET_SUCCEEDED,
  FETCHING_ASSET_FAILED,
  DELETING_ASSET_REQUEST,
  DELETING_ASSET_SUCCEEDED,
  DELETING_ASSET_FAILED,
  FETCHING_ASSET_ANALYTICS_REQUEST,
  FETCHING_ASSET_ANALYTICS_SUCCEEDED,
  FETCHING_ASSET_ANALYTICS_FAILED,
  UPDATING_ASSET_REQUEST,
  UPDATING_ASSET_SUCCEEDED,
  UPDATING_ASSET_FAILED,
  FETCHING_ASSET_SUBTITLE,
  FETCHING_ASSET_SUBTITLE_SUCCEDDED,
  FETCHING_ASSET_SUBTITLE_FAILED,
  UPDATING_SUBTITLE,
  UPDATING_SUBTITLE_SUCCEDDED,
  UPDATING_SUBTITLE_FAILED,
  FETCHING_PREVIEW_ASSET,
  FETCHING_PREVIEW_ASSET_SUCCEEDED,
  FETCHING_PREVIEW_ASSET_FAILED,
  RECORD_ANALYTICS_EVENT,
  RECORDING_ANALYTICS_EVENT_SUCCEEDED,
  RECORDING_ANALYTICS_EVENT_FAILED,
  RECORD_SESSION_ANALYTICS_EVENT,
  RECORDING_SESSION_ANALYTICS_EVENT_SUCCEEDED,
  RECORDING_SESSION_ANALYTICS_EVENT_FAILED,
  UPLOAD_NEW_VERSION,
  UPLOADING_NEW_VERSION_SUCCEEDED,
  UPLOADING_NEW_VERSION_FAILED,
  CANCEL_NEW_VERSION_UPLOAD,
  UPDATE_CLEVERSTORY_ASSET_METADATA_REQUEST,
  UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED,
  UPDATING_CLEVERSTORY_ASSET_METADATA_FAILED,
  FETCH_ASSET_INSIGHTS,
  FETCHING_ASSET_INSIGHTS_SUCCEEDED,
  FETCHING_ASSET_INSIGHTS_FAILED,
  FETCH_ASSET_PREVIEW_TEXT,
  FETCHING_ASSET_PREVIEW_TEXT_SUCCEEDED,
  FETCHING_ASSET_PREVIEW_TEXT_FAILED,
  CLONE_ASSET_REQUEST,
  CLONING_ASSET_SUCCEDDED,
  CLONING_ASSET_FAILED,
  REARRANGE_ASSET_PAGES,
  SELECT_ASSET_PAGE,
  REMOVE_ASSET_PAGE,
  INVALIDATE_SELECTED_ASSET_PAGES,
  CREATING_ASSET_FROM_HUB,
  CREATING_ASSET_FROM_HUB_SUCCEEDED,
  CREATING_ASSET_FROM_HUB_FAILED,
  MODIFY_PAGES_IN_ASSET,
  MODIFYING_PAGES_IN_ASSET_SUCCEEDED,
  MODIFYING_PAGES_IN_ASSET_FAILED,
  INVALIDATE_ASSET_UPDATE,
  TRIGGER_ASSET_PROCESSING_REQUEST,
  TRIGGER_ASSET_PROCESSING_SUCCEEDED,
  TRIGGER_ASSET_PROCESSING_FAILED,
  INVALIDATE_ADD_ASSET_COLLECTIONS,
  INVALIDATE_ASSET_CLONE,
  INVALIDATE_SUBTITLE_UPDATE,
  FETCH_RECOMMENDED_ASSETS,
  FETCHING_RECOMMENDED_ASSETS_SUCCEDDED,
  FETCHING_RECOMMENDED_ASSETS_FAILED,
  FETCHING_PREVIEW_HTML_TEMPLATE,
  FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED,
  FETCHING_PREVIEW_HTML_TEMPLATE_FAILED,
  UPLOAD_FILE_REQUEST,
  UPLOADING_FILE_PROGRESS,
  UPLOADING_FILE_SUCCEDDED,
  UPLOADING_FILE_FAILED,
  CREATE_ASSET_FROM_FILE_REQUEST,
  CREATING_ASSET_FROM_FILE_SUCCEDDED,
  CREATING_ASSET_FROM_FILE_FAILED,
  INVALIDATE_ASSET_UPLOAD,
  FETCHING_ASSET_STORAGE_LIMIT,
  FETCHING_ASSET_STORAGE_LIMIT_SUCCEEDED,
  FETCHING_ASSET_STORAGE_LIMIT_FAILED,
  CREATE_LINK_ASSET_REQUEST,
  CREATING_LINK_ASSET_SUCCEEDED,
  CREATING_LINK_ASSET_FAILED,
  INVALIDATE_LINK_ASSET,
  FETCH_ASSET_PROMPTS,
  FETCHING_ASSET_PROMPTS_SUCCEEDED,
  FETCHING_ASSET_PROMPTS_FAILED,
  INITIATE_UPLOAD_NEW_VERSION,
  INVALIDATE_ASSET_RECOMMENDATIONS,
  FETCHING_CONTENT_RECOMMENDATIONS_REQUEST,
  FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED,
  FETCHING_CONTENT_RECOMMENDATIONS_FAILED,
  ADD_ASSET_TO_CONTENT_SIMILARITY_QUEUE,
  TOGGLE_ASSET_STATUS_IN_CONTENT_SIMILARITY_QUEUE,
  FETCH_DUPLICATE_ASSET,
  FETCHING_DUPLICATE_ASSET_SUCCEDDED,
  FETCHING_DUPLICATE_ASSET_FAILED,
  REPLACE_SIMILAR_ASSET,
  REPLACE_SIMILAR_ASSET_SUCCEEDED,
  REPLACE_SIMILAR_ASSET_FAILED,
  INVALIDATE_SIMILAR_ASSET,
  INVALIDATE_ASSET,
  FETCH_TABLE_OF_CONTENTS,
  FETCHING_TABLE_OF_CONTENTS_SUCCEEDED,
  FETCHING_TABLE_OF_CONTENTS_FAILED,
  UPDATE_TABLE_OF_CONTENTS,
  UPDATING_TABLE_OF_CONTENTS_SUCCEEDED,
  UPDATING_TABLE_OF_CONTENTS_FAILED,
  DELETE_TABLE_OF_CONTENTS,
  DELETING_TABLE_OF_CONTENTS_SUCCEEDED,
  DELETING_TABLE_OF_CONTENTS_FAILED,
  INVALIDATE_UPDATE_TABLE_OF_CONTENTS,
  INVALIDATE_TABLE_OF_CONTENTS,
  CAPTURED_ASSET_VIDEO_NEW_RANGE,
  UPDATED_ASSET_VIDEO_RANGE,
  REMOVED_ASSET_VIDEO_RANGE,
  SYNCING_ASSET_VIEW_RANGE_REQUEST,
  SYNCING_ASSET_VIEW_RANGE_SUCCEDDED,
  SYNCING_ASSET_VIEW_RANGE_FAILED
} from "./actionTypes";

import axios from "axios";
import { takeEvery, takeLatest, call, put } from "redux-saga/effects";
import {
  FetchPreviewAsset,
  FetchAssetSubtitleRequest,
  FetchAssetSubtitleResponse,
  FetchAssetSubtitleErrorResponse,
  UpdateSubtitleRequest,
  UpdateSubtitleResponse,
  UpdateSubtitleErrorResponse,
  RecordAnalyticsEvent,
  RecordAnalyticsEventResponse,
  RecordAnalyticsEventErrorResponse,
  RecordSessionAnalyticsEvent,
  RecordSessionAnalyticsEventResponse,
  RecordSessionAnalyticsEventErrorResponse,
  UploadNewVersionResponse,
  UploadNewVersionErrorResponse,
  FetchAssetInsights,
  FetchAssetInsightsResponse,
  FetchAssetInsightsErrorResponse,
  TriggerAssetProcessingResponse,
  TriggerAssetProcessingErrorResponse,
  Asset,
  CloningAssetErrorResponse,
  CloningAssetRequest,
  CloningAssetResponse,
  CreateAssetRequest,
  DeleteAssetErrorResponse,
  DeleteAssetRequest,
  DeleteAssetResponse,
  FetchAssetAnalyticsRequest,
  FetchAssetAnalyticsResponse,
  FetchAssetErrorResponse,
  FetchAssetRequest,
  FetchAssetResponse,
  FetchPreviewAssetErrorResponse,
  FetchPreviewAssetResponse,
  FetchRecommendedAssetsErrorResponse,
  FetchRecommendedAssetsRequest,
  FetchRecommendedAssetsResponse,
  InvalidateAssetUpdate,
  ModifyAssetPageRequest,
  UpdateAssetErrorResponse,
  UpdateAssetRequest,
  UpdateAssetResponse,
  FetchPreviewHtmlTemplateRequest,
  FetchPreviewHtmlTemplateResponse,
  FetchPreviewHtmlTemplateErrorResponse,
  UploadAssetRequest,
  CreateAssetFromFileRequest,
  CreatingAssetFromFileSucceeded,
  CreatingAssetFromFileFailed,
  UploadAssetProgressRequest,
  UploadAssetResponse,
  UploadAssetErrorResponse,
  CreateLinkAssetRequest,
  CreateLinkAssetResponse,
  CreateLinkAssetErrorResponse,
  InitiateUploadNewVersionRequest,
  UploadNewVersionRequest,
  FetchAssetAnalyticsErrorResponse,
  FetchAssetStorageLimitResponse,
  FetchAssetStorageLimitFailed,
  FetchContentRecommendationsRequest,
  FetchContentRecommendationsResponse,
  FetchContentRecommendationErrorResponse,
  AddAssetToContentSimilarityQueueRequest,
  ToggleAssetStatusInContentSimilarityQueueRequest,
  FetchDuplicateAssetRequest,
  FetchDuplicateAssetResponse,
  FetchDuplicateAssetErrorResponse,
  ReplaceSimilarAssetRequest,
  ReplaceSimilarAssetErrorResponse,
  ReplaceSimilarAssetResponse,
  InvalidateSimilarAssetRequest,
  updateTableOfContentsRequest,
  updateTableOfContentsResponse,
  updateTableOfContentsErrorResponse,
  FetchAssetTableOfContentsResponse,
  FetchAssetTableOfContentsErrorResponse,
  FetchAssetTableOfContentsRequest,
  UpdateVideoRangeRequest,
  CaptureNewVideoRangeRequest,
  SyncAssetVideoRangeRequest,
  SyncAssetVideoRangeResponse,
  SyncAssetVideoRangeErrorResponse
} from "../../types/assets";
import buildUrl from "build-url-ts";


// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;
const ASSETS_BASE_URL = `${apiUrl}/api/2.0/assets`;
const ANALYTICS_BASE_URL = `${apiUrl}/api/2.0/analytics`;
const SEEK_BASE_URL = `${apiUrl}/api/2.0/seek`;

export const fetchAsset = createAction<FetchAssetRequest>(FETCHING_ASSET_REQUEST);

const fetchingAssetSucceeded = createAction<FetchAssetResponse>(FETCHING_ASSET_SUCCEEDED);

const fetchingAssetFailed = createAction<FetchAssetErrorResponse>(FETCHING_ASSET_FAILED);

const fetchAssetSaga = function* (action: ReturnType<typeof fetchAsset>): any {
  const assetId = action.payload.assetId;

  const fetchAssetAPI = () => {
    return axios({
      method: "GET",
      url: `${ASSETS_BASE_URL}/${assetId}`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetAPI);
    yield put(fetchingAssetSucceeded(response));
  } catch (error) {
    yield put(fetchingAssetFailed({ error }));
  }
};

// export const updateAsset = createAction<UpdateAssetRequest>(UPDATING_ASSET_REQUEST);

// const updatingAssetSucceeded = createAction<UpdateAssetResponse>(UPDATING_ASSET_SUCCEEDED);

// const updatingAssetFailed = createAction<UpdateAssetErrorResponse>(UPDATING_ASSET_FAILED);

// const updateAssetSaga = function* (action: ReturnType<typeof updateAsset>): any {
//   const streamId = action.payload.streamId;
//   const assetId = action.payload.entity.id;
//   const parentId = action.payload.parent;

//   const url = new URL(`${ASSETS_URL}/${assetId}`);

//   const updateAssetAPI = () => {
//     return axios({
//       method: "PUT",
//       url: url.toString(),
//       data: action.payload.entity
//     }).then((response) => response.data);
//   };

//   try {
//     const response = yield call(updateAssetAPI);
//     const payload = {
//       ...response,
//       streamId: streamId,
//       parent: parentId
//     }
//     yield put(updatingAssetSucceeded(payload));
//   } catch (error) {
//     yield put(updatingAssetFailed({error, streamId, parentId}));
//   }
// };

//Upload asset
export const uploadAsset = createAction<UploadAssetRequest>(UPLOAD_FILE_REQUEST);
export const uploadAssetProgress = createAction<UploadAssetProgressRequest>(UPLOADING_FILE_PROGRESS);
export const uploadingAssetSucceeded = createAction<UploadAssetResponse>(UPLOADING_FILE_SUCCEDDED);
export const uploadAssetFailed = createAction<UploadAssetErrorResponse>(UPLOADING_FILE_FAILED);

export const createAssetFromFile = createAction<CreateAssetFromFileRequest>(CREATE_ASSET_FROM_FILE_REQUEST);
export const creatingAssetFromFileSucceeded = createAction<CreatingAssetFromFileSucceeded>(CREATING_ASSET_FROM_FILE_SUCCEDDED);
export const creatingAssetFromFileFailed = createAction<CreatingAssetFromFileFailed>(CREATING_ASSET_FROM_FILE_FAILED);

const createAssetFromFileSaga = function* (action: ReturnType<typeof createAssetFromFile>): any {
  const { id, signedUrl } = action.payload as CreateAssetFromFileRequest;

  const url = buildUrl(`${apiUrl}/api/2.0/file_upload`);

  const data = {
    signedUrl: signedUrl
  }

  const createAssetAPI = () => {
    return axios.post(url, data).then((response) => response.data);
  };

  try {
    const response = yield call(createAssetAPI);
    yield put(creatingAssetFromFileSucceeded({
      id: id,
      response: response
    }));
    yield put(addAssetToContentSimilarityQueue({asset: response, initialise: false}));
  } catch (error) {
    yield put(creatingAssetFromFileFailed({
      id: id,
      error: error
    }));
  }
};

export const invalidateAssetUpload = createAction<string>(INVALIDATE_ASSET_UPLOAD);

export const deleteAsset = createAction<DeleteAssetRequest>(DELETING_ASSET_REQUEST);
const deletingAssetSucceeded = createAction<DeleteAssetResponse>(DELETING_ASSET_SUCCEEDED);
const deletingAssetFailed = createAction<DeleteAssetErrorResponse>(DELETING_ASSET_FAILED);

const deleteAssetSaga = function* (action: ReturnType<typeof deleteAsset>): any {
  const assetId = action.payload.id;

  const url = new URL(`${ASSETS_BASE_URL}/${assetId}`);

  const deleteAssetAPI = () => {
    return axios({
      method: "DELETE",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteAssetAPI);
    yield put(deletingAssetSucceeded(response));
  } catch (error) {
    yield put(deletingAssetFailed({ error, id: assetId }));
  }
};

export const fetchAssetAnalytics = createAction<FetchAssetAnalyticsRequest>(FETCHING_ASSET_ANALYTICS_REQUEST);

const fetchingAssetAnalyticsSucceeded = createAction<FetchAssetAnalyticsResponse>(FETCHING_ASSET_ANALYTICS_SUCCEEDED);

const fetchingAssetAnalyticsFailed = createAction<FetchAssetAnalyticsErrorResponse>(FETCHING_ASSET_ANALYTICS_FAILED);

const fetchAssetAnalyticsSaga = function* (action: ReturnType<typeof fetchAssetAnalytics>): any {
  const assetId = action.payload.assetId;
  const streamId = action.payload.streamId;
  const groupId = action.payload.groupId;

  const fetchAssetAnalyticsAPI = () => {
    return axios({
      method: "GET",
      url: `${ASSETS_BASE_URL}/${assetId}/analytics`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetAnalyticsAPI);
    yield put(fetchingAssetAnalyticsSucceeded({ response, assetId, streamId, groupId }));
  } catch (error) {
    yield put(fetchingAssetAnalyticsFailed({ assetId: assetId, error: error }));
  }
};

export const updateAsset = createAction<UpdateAssetRequest>(UPDATING_ASSET_REQUEST);

const updatingAssetSucceeded = createAction<UpdateAssetResponse>(UPDATING_ASSET_SUCCEEDED);

const updatingAssetFailed = createAction<UpdateAssetErrorResponse>(UPDATING_ASSET_FAILED);

export const invalidateAssetUpdations = createAction<InvalidateAssetUpdate>(INVALIDATE_ASSET_UPDATE);

const updateAssetSaga = function* (action: ReturnType<typeof updateAsset>): any {
  const { event } = action.payload;
  const id = action.payload.id;
  const asset = action.payload.request;
  const streamId = action.payload.streamId;
  const parent = action.payload.parent;
  const type = action.payload.type;

  const updateAssetAPI = () => {
    return axios({
      method: "PUT",
      url: `${ASSETS_BASE_URL}/${id}`,
      data: asset
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAssetAPI);
    yield put(updatingAssetSucceeded({ response: response, streamId: streamId, parent: parent }));
    if(type === "rename"){
      event({streamId: streamId, groupId: parent, response: response});
    }
  } catch (error) {
    yield put(updatingAssetFailed({ id: id, error: error, streamId: streamId, parent: parent }));
  }
};

export const fetchPreviewAsset = createAction<FetchPreviewAsset>(FETCHING_PREVIEW_ASSET);

const fetchingPreviewAssetSucceeded = createAction<FetchPreviewAssetResponse>(FETCHING_PREVIEW_ASSET_SUCCEEDED);

const fetchingPreviewAssetFailed = createAction<FetchPreviewAssetErrorResponse>(FETCHING_PREVIEW_ASSET_FAILED);

const fetchPreviewAssetSaga = function* (action: ReturnType<typeof fetchPreviewAsset>): any {
  const { id, shareId, sectionId } = action.payload;

  const fetchPreviewAssetAPI = () => {
    return axios({
      method: "GET",
      url: `${ASSETS_BASE_URL}/${id}/preview`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPreviewAssetAPI);
    yield put(fetchingPreviewAssetSucceeded({ id: id, response, sectionId, shareId }));
  } catch (error) {
    yield put(fetchingPreviewAssetFailed({ id: id, error: error, sectionId, shareId }));
  }
};

export const fetchAssetSubtitle = createAction<FetchAssetSubtitleRequest>(FETCHING_ASSET_SUBTITLE);

const fetchingAssetSubtitleSucceeded = createAction<FetchAssetSubtitleResponse>(FETCHING_ASSET_SUBTITLE_SUCCEDDED);

const fetchingAssetSubtitleFailed = createAction<FetchAssetSubtitleErrorResponse>(FETCHING_ASSET_SUBTITLE_FAILED);

const fetchAssetSubtitleSaga = function* (action: ReturnType<typeof fetchAssetSubtitle>): any {
  const id = action.payload.id;

  const fetchAssetSubtitleAPI = () => {
    return axios({
      method: "GET",
      url: `${ASSETS_BASE_URL}/${id}/subtitle`
    }).then((response) => {
      return response.data;
    });
  };

  try {
    const response = yield call(fetchAssetSubtitleAPI);

    yield put(fetchingAssetSubtitleSucceeded({ response }));
  }
  catch (error) {
    yield put(fetchingAssetSubtitleFailed({ error: error }));
  }
}

export const updateSubtitle = createAction<UpdateSubtitleRequest>(UPDATING_SUBTITLE);

const updatingSubtitleSuccedded = createAction<UpdateSubtitleResponse>(UPDATING_SUBTITLE_SUCCEDDED);

const updatingSubtitleFailed = createAction<UpdateSubtitleErrorResponse>(UPDATING_SUBTITLE_FAILED);

const updateSubtitleSaga = function* (action: ReturnType<typeof updateSubtitle>): any {
  const { id, subtitle } = action.payload;

  const updateSubtitleAPI = () => {
    return axios({
      method: "PUT",
      url: `${ASSETS_BASE_URL}/${id}/subtitle`,
      data: subtitle
    }).then((response) => {
      return response.data;
    });
  };
  try {
    const response = yield call(updateSubtitleAPI);

    yield put(updatingSubtitleSuccedded({ subtitle, response }));
  }
  catch (error) {
    yield put(updatingSubtitleFailed({ error: error }));
  }
};

export const invalidateSubtitleUpdate = createAction<void>(INVALIDATE_SUBTITLE_UPDATE);

export const recordAnalyticsEvent = createAction<RecordAnalyticsEvent>(RECORD_ANALYTICS_EVENT);


const recordingAnalyticsEventSucceeded = createAction<RecordAnalyticsEventResponse>(RECORDING_ANALYTICS_EVENT_SUCCEEDED);

const recordingAnalyticsEventFailed = createAction<RecordAnalyticsEventErrorResponse>(RECORDING_ANALYTICS_EVENT_FAILED);

const recordAnalyticsEventSaga = function* (action: ReturnType<typeof recordAnalyticsEvent>): any {

  const event = action.payload;

  const recordAnalyticsAPI = () => {
    return axios({
      method: "POST",
      url: `${ANALYTICS_BASE_URL}`,
      data: event
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordAnalyticsAPI);
    yield put(recordingAnalyticsEventSucceeded(response));
  } catch (error) {
    yield put(recordingAnalyticsEventFailed({ error: error }));
  }
};

export const recordSessionAnalyticsEvent = createAction<RecordSessionAnalyticsEvent>(RECORD_SESSION_ANALYTICS_EVENT);

const recordingSessionAnalyticsEventSucceeded = createAction<RecordSessionAnalyticsEventResponse>(RECORDING_SESSION_ANALYTICS_EVENT_SUCCEEDED);

const recordingSessionAnalyticsEventFailed = createAction<RecordSessionAnalyticsEventErrorResponse>(RECORDING_SESSION_ANALYTICS_EVENT_FAILED);

const recordSessionAnalyticsEventSaga = function* (action: ReturnType<typeof recordSessionAnalyticsEvent>): any {

  const event = action.payload;

  const recordSessionAnalyticsAPI = () => {
    return axios({
      method: "POST",
      url: `${ANALYTICS_BASE_URL}`,
      data: event
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordSessionAnalyticsAPI);
    yield put(recordingSessionAnalyticsEventSucceeded(response));
  } catch (error) {
    yield put(recordingSessionAnalyticsEventFailed({ error: error }));
  }
}

export const uploadNewVersion = createAction<UploadNewVersionRequest>(UPLOAD_NEW_VERSION);

const uploadingNewVersionSucceeded = createAction<UploadNewVersionResponse>(UPLOADING_NEW_VERSION_SUCCEEDED);

const uploadingNewVersionFailed = createAction<UploadNewVersionErrorResponse>(UPLOADING_NEW_VERSION_FAILED);

const uploadNewVersionSaga = function* (action: ReturnType<typeof uploadNewVersion>): any {

  const { id, signedUrl } = action.payload;

  const data = {
    signedUrl: signedUrl
  };

  const uploadNewVersionAPI = () => {
    return axios({
      method: "POST",
      url: `${ASSETS_BASE_URL}/${id}/version`,
      data: data
    }).then((response) => response.data);
  };

  try {
    const response = yield call(uploadNewVersionAPI);
    yield put(uploadingNewVersionSucceeded({ assetId: id, response: response }));
  } catch (error) {
    yield put(uploadingNewVersionFailed({ error: error }));
  }
};

export const initiateUploadNewVersion = createAction<InitiateUploadNewVersionRequest>(INITIATE_UPLOAD_NEW_VERSION);
export const cancelNewVersionUpload = createAction<string>(CANCEL_NEW_VERSION_UPLOAD);

export const updateCleverstoryAssetMetadata = createAction<any>(UPDATE_CLEVERSTORY_ASSET_METADATA_REQUEST);

const updatingCleverstoryAssetMetadataSucceeded = createAction<any>(UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED);

const updatingCleverstoryAssetMetadataFailed = createAction<any>(UPDATING_CLEVERSTORY_ASSET_METADATA_FAILED);

const updateCleverstoryAssetMetadataSaga = function* (action: ReturnType<typeof updateCleverstoryAssetMetadata>): any {
  const { id } = action.payload;

  const updateCleverstoryAssetMetadataAPI = () => {
    return axios({
      method: "PUT",
      url: `${ASSETS_BASE_URL}/cleverstory_page/${id}`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCleverstoryAssetMetadataAPI);
    yield put(updatingCleverstoryAssetMetadataSucceeded({ response: response }));
  } catch (error) {
    yield put(updatingCleverstoryAssetMetadataFailed({ id: id, error: error }));
  }
};

export const fetchAssetInsights = createAction<FetchAssetInsights>(FETCH_ASSET_INSIGHTS);

const fetchingAssetInsightsSucceeded = createAction<FetchAssetInsightsResponse>(FETCHING_ASSET_INSIGHTS_SUCCEEDED);

const fetchingAssetInsightsFailed = createAction<FetchAssetInsightsErrorResponse>(FETCHING_ASSET_INSIGHTS_FAILED);

const fetchAssetInsightsSaga = function* (action: ReturnType<typeof fetchAssetInsights>): any {
  const { id } = action.payload;
  const fetchAssetInsightsAPI = () => {
    return axios({
      method: "GET",
      url: `${SEEK_BASE_URL}/asset/${id}/insights`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetInsightsAPI);
    yield put(fetchingAssetInsightsSucceeded(response));
  } catch (error) {
    yield put(fetchingAssetInsightsFailed({ error: error }));
  }
}
export const fetchPreviewTextLayer = createAction<any>(FETCH_ASSET_PREVIEW_TEXT);


const fetchingPreviewTextLayerSucceeded = createAction<any>(FETCHING_ASSET_PREVIEW_TEXT_SUCCEEDED);

const fetchingPreviewTextLayerFailed = createAction<any>(FETCHING_ASSET_PREVIEW_TEXT_FAILED);

const fetchPreviewTextLayerSaga = function* (action: ReturnType<typeof fetchPreviewTextLayer>): any {
  const id = action.payload;

  const fetchPreviewTextLayerAPI = () => {
    return axios({
      method: "GET",
      url: `${ASSETS_BASE_URL}/${id}/preview/text`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPreviewTextLayerAPI);
    yield put(fetchingPreviewTextLayerSucceeded(response));
  } catch (error) {
    yield put(fetchingPreviewTextLayerFailed({ error: error }));
  }
};
//clone asset
export const cloneAsset = createAction<CloningAssetRequest>(CLONE_ASSET_REQUEST);

const cloningAssetSucceeded = createAction<CloningAssetResponse>(CLONING_ASSET_SUCCEDDED);

const cloningAssetFailed = createAction<CloningAssetErrorResponse>(CLONING_ASSET_FAILED);

const cloneAssetSaga = function* (action: ReturnType<typeof cloneAsset>): any {
  const { id, destination } = action.payload;

  const cloneAssetAPI = async () => {
    const response = await axios({
      method: "POST",
      url: `${ASSETS_BASE_URL}/${id}/clone`,
      data: destination
    });
    return response.data;
  };

  try {
    const response = yield call(cloneAssetAPI);
    yield put(cloningAssetSucceeded(response));
    return response;
  } catch (error) {
    yield put(cloningAssetFailed({errors: error}));
    throw error;
  }
};

// create asset page selection
export const selectAssetPage = createAction<any>(SELECT_ASSET_PAGE);
export const removeAssetPage = createAction<any>(REMOVE_ASSET_PAGE);
export const invalidateSelectedAssetPages = createAction(
  INVALIDATE_SELECTED_ASSET_PAGES,
);
export const rearrangeAssetPages = createAction<any>(REARRANGE_ASSET_PAGES);

export const createAsset = createAction<CreateAssetRequest>(CREATING_ASSET_FROM_HUB);
const creatingAssetSucceeded = createAction<Asset>(CREATING_ASSET_FROM_HUB_SUCCEEDED);
const creatingAssetFailed = createAction<any>(CREATING_ASSET_FROM_HUB_FAILED);

const createAssetSaga = function* (action: ReturnType<typeof createAsset>): any {
  const { requestBody, type } = action.payload;
  const createAssetAPI = () => {
    return axios({
      method: "POST",
      url: `${ASSETS_BASE_URL}/create-asset/${type}`,
      data: requestBody
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createAssetAPI);
    yield put(creatingAssetSucceeded(response));
  } catch (error) {
    yield put(creatingAssetFailed({ error: error }));
  }
}

export const modifyAssetPages = createAction<ModifyAssetPageRequest>(MODIFY_PAGES_IN_ASSET);
const modifyingAssetPagesSucceeded = createAction<any>(MODIFYING_PAGES_IN_ASSET_SUCCEEDED);
const modifyingAssetPagesFailed = createAction<any>(MODIFYING_PAGES_IN_ASSET_FAILED);

const modifyAssetPageSaga = function* (action: ReturnType<typeof modifyAssetPages>): any {
  const { requestBody, assetId, assetType } = action.payload;
  const createAssetAPI = () => {
    return axios({
      method: "PUT",
      url: `${ASSETS_BASE_URL}/${assetId}/pages/merge/${assetType}`,
      data: requestBody
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createAssetAPI);
    yield put(modifyingAssetPagesSucceeded(response));
  } catch (error) {
    yield put(modifyingAssetPagesFailed({ error: error }));
  }
}

export const triggerAssetProcessing = createAction<string>(TRIGGER_ASSET_PROCESSING_REQUEST);
const triggerAssetProcessingSucceeded = createAction<TriggerAssetProcessingResponse>(TRIGGER_ASSET_PROCESSING_SUCCEEDED);
const triggerAssetProcessingFailed = createAction<TriggerAssetProcessingErrorResponse>(TRIGGER_ASSET_PROCESSING_FAILED);

const triggerAssetProcessingSaga = function* (action: ReturnType<typeof triggerAssetProcessing>): any {
  const id = action.payload;

  const triggerAssetProcessingAPI = () => {
    return axios({
      method: "POST",
      url: `${ASSETS_BASE_URL}/${id}/process`,
    }).then(response => response.data);
  };

  try {
    const response = yield call(triggerAssetProcessingAPI);
    yield put(triggerAssetProcessingSucceeded({ response }));
  } catch (error) {
    yield put(triggerAssetProcessingFailed({ error: error }));
  }
};

export const invalidateAddAssetCollections = createAction<void>(INVALIDATE_ADD_ASSET_COLLECTIONS);

export const invalidateAssetClone = createAction<void>(INVALIDATE_ASSET_CLONE);

export const fetchPreviewHtmlTemplate = createAction<FetchPreviewHtmlTemplateRequest>(FETCHING_PREVIEW_HTML_TEMPLATE);

const fetchingPreviewHtmlTemplateSucceeded = createAction<FetchPreviewHtmlTemplateResponse>(FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED);

const fetchingPreviewHtmlTemplateFailed = createAction<FetchPreviewHtmlTemplateErrorResponse>(FETCHING_PREVIEW_HTML_TEMPLATE_FAILED);

const fetchPreviewHtmlTemplateSaga = function* (action: ReturnType<typeof fetchPreviewHtmlTemplate>): any {
  const { url } = action.payload;

  const fetchPreviewHtmlTemplateAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPreviewHtmlTemplateAPI);
    yield put(fetchingPreviewHtmlTemplateSucceeded(response));
  } catch (error) {
    yield put(fetchingPreviewHtmlTemplateFailed({ error: error }));
  }
}

export const createLinkAssetRequest = createAction<CreateLinkAssetRequest>(CREATE_LINK_ASSET_REQUEST);
export const createLinkAssetSucceeded = createAction<CreateLinkAssetResponse>(CREATING_LINK_ASSET_SUCCEEDED);
export const createLinkAssetFailed = createAction<CreateLinkAssetErrorResponse>(CREATING_LINK_ASSET_FAILED);
export const invalidateLinkAsset = createAction<string>(INVALIDATE_LINK_ASSET);

const createUrlAssetSaga = function* (action: ReturnType<typeof createLinkAssetRequest>): any {
  const { id, url } = action.payload as CreateLinkAssetRequest;

  const createLinkAssetAPI = () => {
    return axios({
      method: "POST",
      url: `${ASSETS_BASE_URL}/url`,
      data: { url }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createLinkAssetAPI);
    yield put(createLinkAssetSucceeded({
      id: id,
      asset: response,
      url,
    }));
  } catch (error) {
    yield put(createLinkAssetFailed({ id, error: error, url }));
  }

}
//fetch recommended assets 
export const fetchRecommendedAssets = createAction<FetchRecommendedAssetsRequest>(FETCH_RECOMMENDED_ASSETS);
const fetchingRecommendedAssetsSuccedded = createAction<FetchRecommendedAssetsResponse>(FETCHING_RECOMMENDED_ASSETS_SUCCEDDED);
const fetchingRecommendedAssetsFailed = createAction<FetchRecommendedAssetsErrorResponse>(FETCHING_RECOMMENDED_ASSETS_FAILED);

export const invalidateAssetRecommendations = createAction<void>(INVALIDATE_ASSET_RECOMMENDATIONS);

const fetchRecommendedAssetsSaga = function* (action: ReturnType<typeof fetchRecommendedAssets>): any {

  const { id } = action.payload;

  const fetchRecommendedAssetsAPI = () => {
    return axios({
      method: "GET",
      url: `${ASSETS_BASE_URL}/${id}/recommendations`,
    }).then(response => response.data);
  };

  try {
    const response = yield call(fetchRecommendedAssetsAPI);
    yield put(fetchingRecommendedAssetsSuccedded({ response }));
  } catch (error) {
    yield put(fetchingRecommendedAssetsFailed({ error: error }));
  }

};

//fetch asset storage limit
export const fetchAssetStorageLimit = createAction(FETCHING_ASSET_STORAGE_LIMIT);
const fetchingAssetStorageLimitSucceeded = createAction<FetchAssetStorageLimitResponse>(FETCHING_ASSET_STORAGE_LIMIT_SUCCEEDED);
const fetchingAssetStorageLimitFailed = createAction<FetchAssetStorageLimitFailed>(FETCHING_ASSET_STORAGE_LIMIT_FAILED);
const fetchAssetStorageLimitSaga = function* (action: ReturnType<typeof fetchAssetStorageLimit>): any {
  const fetchAssetStorageLimitAPI = () => {
    return axios({
      method: "GET",
      url: `${ASSETS_BASE_URL}/storage-limit`
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchAssetStorageLimitAPI);
    yield put(fetchingAssetStorageLimitSucceeded(response));
  } catch (error) {
    yield put(fetchingAssetStorageLimitFailed({error}));
  }
}

export const fetchAssetPrompts = createAction<string>(FETCH_ASSET_PROMPTS);
const fetchingAssetPromptsSucceeded = createAction<any>(FETCHING_ASSET_PROMPTS_SUCCEEDED);
const fetchingAssetPromptsFailed = createAction<any>(FETCHING_ASSET_PROMPTS_FAILED);

const fetchAssetPromptsSaga = function* (action: ReturnType<typeof fetchAssetPrompts>): any {
  const fetchAssetPromptsAPI = () => {
    const id = action.payload;

    return axios({
      method: "GET",
      url: `${SEEK_BASE_URL}/asset/${id}/prompts`,
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchAssetPromptsAPI);
    yield put(fetchingAssetPromptsSucceeded(response));
  } catch (error) {
    yield put(fetchingAssetPromptsFailed({ error: error }));
  }
}

export const fetchContentRecommendations = createAction<FetchContentRecommendationsRequest>(FETCHING_CONTENT_RECOMMENDATIONS_REQUEST);

const fetchingContentRecommendationsSucceeded = createAction<FetchContentRecommendationsResponse>(FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED);

const fetchingContentRecommendationsFailed = createAction<FetchContentRecommendationErrorResponse>(FETCHING_CONTENT_RECOMMENDATIONS_FAILED);

const fetchContentRecommendationsSaga = function* (action: ReturnType<typeof fetchContentRecommendations>): any {

  const fetchContentRecommendationsAPI = (selectedAssets: any) => {
    return axios({
      method: "POST",
      url: `${ASSETS_BASE_URL}/content-recommendations`,
      data: selectedAssets
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchContentRecommendationsAPI,action.payload);
    yield put(fetchingContentRecommendationsSucceeded(response));
  } catch (error) {
    yield put(fetchingContentRecommendationsFailed({ error: error }));
  }
};

const addAssetToContentSimilarityQueue = createAction<AddAssetToContentSimilarityQueueRequest>(ADD_ASSET_TO_CONTENT_SIMILARITY_QUEUE);
export const toggleAssetStatusInContentSimilarityQueue = createAction<ToggleAssetStatusInContentSimilarityQueueRequest>(TOGGLE_ASSET_STATUS_IN_CONTENT_SIMILARITY_QUEUE);

// fetch duplicate assets
export const fetchDuplicateAsset = createAction<FetchDuplicateAssetRequest>(FETCH_DUPLICATE_ASSET);
const fetchingDuplicateAssetSucceeded = createAction<FetchDuplicateAssetResponse>(FETCHING_DUPLICATE_ASSET_SUCCEDDED);
const fetchingDuplicateAssetFailed = createAction<FetchDuplicateAssetErrorResponse>(FETCHING_DUPLICATE_ASSET_FAILED);

const fetchDuplicateAssetSaga = function* (action: ReturnType<typeof fetchDuplicateAsset>): any {
  const fetchDuplicateAssetAPI = () => {
    const request = action.payload;

    return axios({
      method: "POST",
      url: `${ASSETS_BASE_URL}/duplicate-assets`,
      data: request
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchDuplicateAssetAPI);
    yield put(fetchingDuplicateAssetSucceeded({asset: response}));
  } catch (error) {
    yield put(fetchingDuplicateAssetFailed({ error: error }));
  }
}

// replace asset
export const replaceSimilarAsset = createAction<ReplaceSimilarAssetRequest>(REPLACE_SIMILAR_ASSET);
const replaceSimilarAssetSucceeded = createAction<ReplaceSimilarAssetResponse>(REPLACE_SIMILAR_ASSET_SUCCEEDED);
const replaceSimilarAssetFailed = createAction<ReplaceSimilarAssetErrorResponse>(REPLACE_SIMILAR_ASSET_FAILED);

const replaceSimilarAssetSaga = function* (action: ReturnType<typeof replaceSimilarAsset>): any {
  const { id, assetId } = action.payload;

  const data = {
    newAssetId: id,
    existingAssetId: assetId
  }

  const replaceSimilarAssetAPI = () => {
    return axios({
      method: "POST",
      url: `${ASSETS_BASE_URL}/replace`,
      data: data
    }).then((response) => response.data);
  };

  try {
    const response = yield call(replaceSimilarAssetAPI);
    yield put(replaceSimilarAssetSucceeded( response ));
  } catch (error) {
    yield put(replaceSimilarAssetFailed({ error: error }));
  }
};

export const invalidateSimiarAsset = createAction<InvalidateSimilarAssetRequest>(INVALIDATE_SIMILAR_ASSET);

export const fetchTableOfContents = createAction<FetchAssetTableOfContentsRequest>(FETCH_TABLE_OF_CONTENTS);
const fetchingTableOfContentsSucceeded = createAction<FetchAssetTableOfContentsResponse>(FETCHING_TABLE_OF_CONTENTS_SUCCEEDED);
const fetchingTableOfContentsFailed = createAction<FetchAssetTableOfContentsErrorResponse>(FETCHING_TABLE_OF_CONTENTS_FAILED);
const fetchTableOfContentsSaga = function* (action: ReturnType<typeof fetchTableOfContents>): any {
  const { id } = action.payload;
  const fetchTableOfContentsAPI = () => {
    return axios({
      method: "GET",
      url: `${ASSETS_BASE_URL}/${id}/table_of_contents`
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchTableOfContentsAPI);
    yield put(fetchingTableOfContentsSucceeded(response));
  }
  catch (error) {
    yield put(fetchingTableOfContentsFailed({ id, error: error }));
  }
};

export const updateTableOfContents = createAction<updateTableOfContentsRequest>(UPDATE_TABLE_OF_CONTENTS);
const updatingTableOfContentsSucceeded = createAction<FetchAssetTableOfContentsResponse>(UPDATING_TABLE_OF_CONTENTS_SUCCEEDED);
const updatingTableOfContentsFailed = createAction<updateTableOfContentsErrorResponse>(UPDATING_TABLE_OF_CONTENTS_FAILED);

export const invalidateUpdateTableOfContents = createAction<void>(INVALIDATE_UPDATE_TABLE_OF_CONTENTS);

const updateTableOfContentsSaga = function* (action: ReturnType<typeof updateTableOfContents>): any {
  const { request, assetId } = action.payload;
  const updateTableOfContentsAPI = () => {
    return axios({
      method: "POST",
      url: `${ASSETS_BASE_URL}/${assetId}/table_of_contents`,
      data: request
    }).then((response) => response.data);
  };
  try {
    const response = yield call(updateTableOfContentsAPI);
    yield put(updatingTableOfContentsSucceeded(response));
  } catch (error) {
    yield put(updatingTableOfContentsFailed({ assetId, error: error }));
  }
};

export const deleteTableOfContents = createAction<{ id: string }>(DELETE_TABLE_OF_CONTENTS);
const deletingTableOfContentsSucceeded = createAction<void>(DELETING_TABLE_OF_CONTENTS_SUCCEEDED);
const deletingTableOfContentsFailed = createAction<{ error: any }>(DELETING_TABLE_OF_CONTENTS_FAILED);

const deleteTableOfContentsSaga = function* (action: ReturnType<typeof deleteTableOfContents>): any {
  const { id } = action.payload;
  const deleteTableOfContentsAPI = () => {
    return axios({
      method: "DELETE",
      url: `${ASSETS_BASE_URL}/${id}/table_of_contents`
    }).then((response) => response.data);
  };
  try {
    const response = yield call(deleteTableOfContentsAPI);
    yield put(deletingTableOfContentsSucceeded(response));
  } catch (error) {
    yield put(deletingTableOfContentsFailed({ error: error }));
  }
};

export const invaliadateTableOfContents = createAction<void>(INVALIDATE_TABLE_OF_CONTENTS);

export function captureNewVideoRange(startRange) {
  return function (dispatch) {
    var id = '_' + Math.random().toString(36).substr(2, 9);

    dispatch({
      type: CAPTURED_ASSET_VIDEO_NEW_RANGE,
      payload: {
        id: id,
        external_id: null,
        start: startRange,
        end: startRange,
        synced: false,
        syncing: false,
        updatedDate: new Date().getTime(),
        syncedDate: null
      }
    });

    return id;
  }
}

export const updateVideoRange = createAction<UpdateVideoRangeRequest>(UPDATED_ASSET_VIDEO_RANGE);
export const removeVideoRange = createAction<{id: string}>(REMOVED_ASSET_VIDEO_RANGE);

export const syncAssetVideoRange = createAction<SyncAssetVideoRangeRequest>(SYNCING_ASSET_VIEW_RANGE_REQUEST);
export const syncAssetVideoRangeSucceeded = createAction<SyncAssetVideoRangeResponse>(SYNCING_ASSET_VIEW_RANGE_SUCCEDDED);
export const syncAssetVideoRangeFailed = createAction<SyncAssetVideoRangeErrorResponse>(SYNCING_ASSET_VIEW_RANGE_FAILED);

const syncAssetVideoRangeSaga = function* (action: ReturnType<typeof syncAssetVideoRange>): any {
  const { id, event } = action.payload;
  const syncAssetVideoRangeAPI = () => {
    return axios({
      method: "POST",
      url: ANALYTICS_BASE_URL,
      data: event
    }).then((response) => response.data);
  };
  try {
    const response = yield call(syncAssetVideoRangeAPI);
    yield put(syncAssetVideoRangeSucceeded({ id, range : response }));
  } catch (error) {
    yield put(syncAssetVideoRangeFailed({ id, error: error }));
  }
};

export const invalidateAsset = createAction<string>(INVALIDATE_ASSET);

export default function* assetsSaga() {
  yield takeEvery(FETCHING_ASSET_REQUEST, fetchAssetSaga);
  yield takeEvery(CREATE_ASSET_FROM_FILE_REQUEST, createAssetFromFileSaga);
  yield takeEvery(DELETING_ASSET_REQUEST, deleteAssetSaga);
  yield takeEvery(FETCHING_ASSET_ANALYTICS_REQUEST, fetchAssetAnalyticsSaga);
  yield takeEvery(FETCHING_ASSET_SUBTITLE, fetchAssetSubtitleSaga);
  yield takeEvery(UPDATING_SUBTITLE, updateSubtitleSaga);
  yield takeEvery(UPDATING_ASSET_REQUEST, updateAssetSaga);
  yield takeEvery(FETCHING_PREVIEW_ASSET, fetchPreviewAssetSaga);
  yield takeEvery(RECORD_ANALYTICS_EVENT, recordAnalyticsEventSaga);
  yield takeEvery(RECORD_SESSION_ANALYTICS_EVENT, recordSessionAnalyticsEventSaga);
  yield takeEvery(UPLOAD_NEW_VERSION, uploadNewVersionSaga);
  yield takeEvery(UPDATE_CLEVERSTORY_ASSET_METADATA_REQUEST, updateCleverstoryAssetMetadataSaga);
  yield takeEvery(FETCH_ASSET_INSIGHTS, fetchAssetInsightsSaga);
  yield takeEvery(FETCH_ASSET_PREVIEW_TEXT, fetchPreviewTextLayerSaga);
  yield takeEvery(CLONE_ASSET_REQUEST, cloneAssetSaga);
  yield takeEvery(CREATING_ASSET_FROM_HUB, createAssetSaga);
  yield takeEvery(MODIFY_PAGES_IN_ASSET, modifyAssetPageSaga);
  yield takeEvery(TRIGGER_ASSET_PROCESSING_REQUEST, triggerAssetProcessingSaga);
  yield takeEvery(FETCHING_PREVIEW_HTML_TEMPLATE, fetchPreviewHtmlTemplateSaga);
  yield takeEvery(FETCHING_ASSET_STORAGE_LIMIT, fetchAssetStorageLimitSaga);
  yield takeEvery(CREATE_LINK_ASSET_REQUEST, createUrlAssetSaga);
  yield takeEvery(FETCH_RECOMMENDED_ASSETS, fetchRecommendedAssetsSaga);
  yield takeEvery(FETCH_ASSET_PROMPTS, fetchAssetPromptsSaga);
  yield takeEvery(FETCHING_CONTENT_RECOMMENDATIONS_REQUEST,fetchContentRecommendationsSaga);
  yield takeEvery(FETCH_DUPLICATE_ASSET, fetchDuplicateAssetSaga);
  yield takeEvery(REPLACE_SIMILAR_ASSET, replaceSimilarAssetSaga);
  yield takeEvery(FETCH_TABLE_OF_CONTENTS, fetchTableOfContentsSaga);
  yield takeEvery(UPDATE_TABLE_OF_CONTENTS, updateTableOfContentsSaga);
  yield takeEvery(DELETE_TABLE_OF_CONTENTS, deleteTableOfContentsSaga);
  yield takeEvery(SYNCING_ASSET_VIEW_RANGE_REQUEST, syncAssetVideoRangeSaga);
}
